/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalSettingsRequest
 */
export interface GlobalSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    loaderLabelName?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    firmwareLabelName?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    uiLabelName?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    customFirmware1LabelName?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    customFirmware2LabelName?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    customFirmware3LabelName?: string;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    incorrectRequestsItemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    deviceItemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    actionHistoryItemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    upgradeRuleItemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    jobItemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    firmwareItemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    historyItemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    stbGroupItemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    jobParallelThreads?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    jobExportBatchSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    jobExportBatchWaitDuration?: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    jobBatchWaitDuration?: string;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    jobBatchSize?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    jobMaxQueued?: number;
    /**
     * 
     * @type {number}
     * @memberof GlobalSettingsRequest
     */
    maxDeviceHistory?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsRequest
     */
    enableDeviceHistory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsRequest
     */
    enableTags?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsRequest
     */
    enableIpGroup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsRequest
     */
    enableProvisioning?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsRequest
     */
    enableAutomationApi?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    appUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsRequest
     */
    enableStbCommands?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlobalSettingsRequest
     */
    authLockMessage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsRequest
     */
    enableRescue?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsRequest
     */
    enableCompareFwVersions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSettingsRequest
     */
    enableDisablingExtendedVersioning?: boolean;
}

export function GlobalSettingsRequestFromJSON(json: any): GlobalSettingsRequest {
    return GlobalSettingsRequestFromJSONTyped(json, false);
}

export function GlobalSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalSettingsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loaderLabelName': !exists(json, 'loaderLabelName') ? undefined : json['loaderLabelName'],
        'firmwareLabelName': !exists(json, 'firmwareLabelName') ? undefined : json['firmwareLabelName'],
        'uiLabelName': !exists(json, 'uiLabelName') ? undefined : json['uiLabelName'],
        'customFirmware1LabelName': !exists(json, 'customFirmware1LabelName') ? undefined : json['customFirmware1LabelName'],
        'customFirmware2LabelName': !exists(json, 'customFirmware2LabelName') ? undefined : json['customFirmware2LabelName'],
        'customFirmware3LabelName': !exists(json, 'customFirmware3LabelName') ? undefined : json['customFirmware3LabelName'],
        'incorrectRequestsItemsPerPage': !exists(json, 'incorrectRequestsItemsPerPage') ? undefined : json['incorrectRequestsItemsPerPage'],
        'deviceItemsPerPage': !exists(json, 'deviceItemsPerPage') ? undefined : json['deviceItemsPerPage'],
        'actionHistoryItemsPerPage': !exists(json, 'actionHistoryItemsPerPage') ? undefined : json['actionHistoryItemsPerPage'],
        'upgradeRuleItemsPerPage': !exists(json, 'upgradeRuleItemsPerPage') ? undefined : json['upgradeRuleItemsPerPage'],
        'jobItemsPerPage': !exists(json, 'jobItemsPerPage') ? undefined : json['jobItemsPerPage'],
        'firmwareItemsPerPage': !exists(json, 'firmwareItemsPerPage') ? undefined : json['firmwareItemsPerPage'],
        'historyItemsPerPage': !exists(json, 'historyItemsPerPage') ? undefined : json['historyItemsPerPage'],
        'stbGroupItemsPerPage': !exists(json, 'stbGroupItemsPerPage') ? undefined : json['stbGroupItemsPerPage'],
        'jobParallelThreads': !exists(json, 'jobParallelThreads') ? undefined : json['jobParallelThreads'],
        'jobExportBatchSize': !exists(json, 'jobExportBatchSize') ? undefined : json['jobExportBatchSize'],
        'jobExportBatchWaitDuration': !exists(json, 'jobExportBatchWaitDuration') ? undefined : json['jobExportBatchWaitDuration'],
        'jobBatchWaitDuration': !exists(json, 'jobBatchWaitDuration') ? undefined : json['jobBatchWaitDuration'],
        'jobBatchSize': !exists(json, 'jobBatchSize') ? undefined : json['jobBatchSize'],
        'jobMaxQueued': !exists(json, 'jobMaxQueued') ? undefined : json['jobMaxQueued'],
        'maxDeviceHistory': !exists(json, 'maxDeviceHistory') ? undefined : json['maxDeviceHistory'],
        'enableDeviceHistory': !exists(json, 'enableDeviceHistory') ? undefined : json['enableDeviceHistory'],
        'enableTags': !exists(json, 'enableTags') ? undefined : json['enableTags'],
        'enableIpGroup': !exists(json, 'enableIpGroup') ? undefined : json['enableIpGroup'],
        'enableProvisioning': !exists(json, 'enableProvisioning') ? undefined : json['enableProvisioning'],
        'enableAutomationApi': !exists(json, 'enableAutomationApi') ? undefined : json['enableAutomationApi'],
        'appUrl': !exists(json, 'appUrl') ? undefined : json['appUrl'],
        'enableStbCommands': !exists(json, 'enableStbCommands') ? undefined : json['enableStbCommands'],
        'authLockMessage': !exists(json, 'authLockMessage') ? undefined : json['authLockMessage'],
        'enableRescue': !exists(json, 'enableRescue') ? undefined : json['enableRescue'],
        'enableCompareFwVersions': !exists(json, 'enableCompareFwVersions') ? undefined : json['enableCompareFwVersions'],
        'enableDisablingExtendedVersioning': !exists(json, 'enableDisablingExtendedVersioning') ? undefined : json['enableDisablingExtendedVersioning'],
    };
}

export function GlobalSettingsRequestToJSON(value?: GlobalSettingsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loaderLabelName': value.loaderLabelName,
        'firmwareLabelName': value.firmwareLabelName,
        'uiLabelName': value.uiLabelName,
        'customFirmware1LabelName': value.customFirmware1LabelName,
        'customFirmware2LabelName': value.customFirmware2LabelName,
        'customFirmware3LabelName': value.customFirmware3LabelName,
        'incorrectRequestsItemsPerPage': value.incorrectRequestsItemsPerPage,
        'deviceItemsPerPage': value.deviceItemsPerPage,
        'actionHistoryItemsPerPage': value.actionHistoryItemsPerPage,
        'upgradeRuleItemsPerPage': value.upgradeRuleItemsPerPage,
        'jobItemsPerPage': value.jobItemsPerPage,
        'firmwareItemsPerPage': value.firmwareItemsPerPage,
        'historyItemsPerPage': value.historyItemsPerPage,
        'stbGroupItemsPerPage': value.stbGroupItemsPerPage,
        'jobParallelThreads': value.jobParallelThreads,
        'jobExportBatchSize': value.jobExportBatchSize,
        'jobExportBatchWaitDuration': value.jobExportBatchWaitDuration,
        'jobBatchWaitDuration': value.jobBatchWaitDuration,
        'jobBatchSize': value.jobBatchSize,
        'jobMaxQueued': value.jobMaxQueued,
        'maxDeviceHistory': value.maxDeviceHistory,
        'enableDeviceHistory': value.enableDeviceHistory,
        'enableTags': value.enableTags,
        'enableIpGroup': value.enableIpGroup,
        'enableProvisioning': value.enableProvisioning,
        'enableAutomationApi': value.enableAutomationApi,
        'appUrl': value.appUrl,
        'enableStbCommands': value.enableStbCommands,
        'authLockMessage': value.authLockMessage,
        'enableRescue': value.enableRescue,
        'enableCompareFwVersions': value.enableCompareFwVersions,
        'enableDisablingExtendedVersioning': value.enableDisablingExtendedVersioning,
    };
}

